import {SyncConfig} from "@/stores/plugins/sync/types";

/**
 * Configuration for the sync plugin.
 *
 * This configuration defines which stores are enabled for synchronization
 * and which properties of those stores should be synchronized.
 * If `properties` is set to `null`, the entire store state will be synchronized.
 */
export const SYNC_CONFIG: SyncConfig = {
    stores: {
        subscriptionPlan: {
            enabled: true,
            properties: ['subscriptionPlans']
        }
    }
};
